import {UpdateAction, UpdateType} from "../../gd/manager/delta-handler/types"
import Resources from "../resources"

export default function resourcesProcessUpdates(resources:Resources, updates:(false|undefined|UpdateAction)[]) {

    let anyChanges = false


    _.map(updates, (update) => {

        if (!update) return

        let isChanged = false
        const payload = update.payload

        switch (update.updateType) {

            case UpdateType.MEETING_DELTA:
            case UpdateType.MEETING_DELETE:
            case UpdateType.MEETING_NEW:
                if (resources.meetings?.processUpdate(update)) {
                    isChanged = true
                }
                break

            case UpdateType.TASK_NEW:
            case UpdateType.TASK_DELTA:
            case UpdateType.TASK_DELETE:
                if (resources.tasks?.processUpdate(update)) {
                    isChanged = true
                }
                break

            case UpdateType.EVENT_NEW:
            case UpdateType.EVENT_DELTA:
            case UpdateType.EVENT_DELETE:
                if (resources.events?.processUpdate(update)) {
                    isChanged = true
                }
                break

            case UpdateType.EXPENSE_NEW:
            case UpdateType.EXPENSE_DELTA:
            case UpdateType.EXPENSE_DELETE:
                if (resources.expenses?.processUpdate(update)) {
                    isChanged = true
                }
                break


            default:
                break
        }


        if (isChanged) anyChanges = true
    })

    if (anyChanges) {
        // console.log("resources collection has changed .... ")
        resources.deltaHandlerCallback && resources.deltaHandlerCallback()
    }
}